import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';

@Component({
  selector: 'cigna-dialog-site-help-public',
  templateUrl: './dialog-site-help-public.component.html',
  styleUrls: ['./dialog-site-help-public.component.scss'],
})
export class DialogSiteHelpPublicComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogSiteHelpPublicComponent>,
    private featureToggleFacade: FeatureTogglesFacade,
  ) {}
  newSiteHelpFlag$ = this.featureToggleFacade.featuresEnabled([
    'ftr-chcp-nova-team-web-site-help-content',
  ]);
}
